module.exports = __webpack_public_path__ + "img/0002.b4d9f97e.jpg";